// ----------------------------------------------------------------------

import type { Theme } from '@mui/material/styles';

export default function Switch(_theme: Theme) {
  return {
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          boxShadow: 'none',
          width: 16,
          height: 16,
          margin: 2,
        },
        root: {
          padding: 8,
        },
        track: {
          borderRadius: 22 / 2,
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
          },
        },
      },
    },
  };
}
